document.addEventListener("DOMContentLoaded", () => {
  class PcSelectorPopup extends HTMLElement {
    constructor() {
      super();

      this.data = [];
      this.selectedValue = null;
      this.anchorEl = null;

      this.style.display = "none";

      // portal
      this.portal = document.createElement("div");
      this.portal.className = this.getAttribute("portal-class");
      this.portal.style.position = "absolute";
      this.portal.style.zIndex = "24";
      this.portal.style.display = "none";

      document.body.appendChild(this.portal);

      this.onDocClick = this.onDocClick.bind(this);
    }

    open({ data, selectedValue, anchorEl }) {
      this.data = data;
      this.selectedValue = selectedValue;
      this.anchorEl = anchorEl;

      $("body").css("overflow-x", "hidden");

      this.render();
      this.position();
      this.portal.style.display = "block";

      document.addEventListener("click", this.onDocClick);
    }

    close() {
      this.portal.style.display = "none";
      $("body").css("overflow-x", "");
      document.removeEventListener("click", this.onDocClick);
    }

    render() {
      this.portal.innerHTML = "";

      this.data.forEach((product) => {
        const isSelected = product.handle === this.selectedValue;
        const item = document.createElement("div");

        item.className = `xmas-swiper-card-selector-option${isSelected ? " selected" : ""}`;
        item.dataset.value = product.handle;
        item.textContent = product.title;

        item.addEventListener("click", (e) => {
          e.stopPropagation();
          this.confirm(product.handle);
        });

        this.portal.appendChild(item);
      });

      // 阻止点 options 自身冒泡
      this.portal.addEventListener("click", (e) => e.stopPropagation());
    }

    position() {
      if (!this.anchorEl) return;

      const rect = this.anchorEl.getBoundingClientRect();

      this.portal.style.top = rect.bottom + window.scrollY + "px";
      this.portal.style.left = rect.left + window.scrollX + "px";
      this.portal.style.width = rect.width + "px";
    }

    confirm(value) {
      this.dispatchEvent(
        new CustomEvent("confirm", {
          detail: { value },
          bubbles: true,
          composed: true,
        })
      );
      this.close();
    }

    onDocClick() {
      this.close();
    }

    disconnectedCallback() {
      this.close();
      if (this.portal.parentNode) {
        this.portal.parentNode.removeChild(this.portal);
      }
    }
  }

  customElements.define("pc-selector-popup", PcSelectorPopup);
});
